import QueryString from "qs"
import http from "../index"
import {
  apiAssigned,
  apiFastAssigned,
  apiAssignPermissions,
  apiCallLog,
  apiExportOrder,
  apiGetAllPermission,
  apiGetDistrict,
  apiGetGrowthStatistics,
  apiGetProvince,
  apiGetRolePermissions,
  apiGetStatistics,
  apiGetTopSales,
  apiGetWard,
  apiListPersonnel,
  apiOrderUpdateStatus,
  apiSalary,
  apiTotalPrice,
  apiUpdateStatusOrderVTP,
  apiCreateSalaryConfig,
  apiGetSalaryConfig,
  apiGetListSalaryConfig,
  apiGetDetailSalaryConfig,
  apiUpdateSalaryConfig,
  apiCreateSalaryConfigV2,
  apiUpdateSalaryConfigV2,
  apiGetListSalaryConfigV2,
  apiGetDetailSalaryConfigV2,
  apiDeleteSalaryConfigV2,
  apiGetAssignedDepartmentsV2,
  apiMonthlySalaryV2List,
  apiMonthlySalaryV2Detail,
  apiMonthlySalaryV2Calculate,
  apiMonthlySalaryV2UpdateResponsibility,
  apiMonthlySalaryV2Adjust,
  apiMonthlySalaryV2Revert,
  apiMonthlySalaryV2ToggleClose,
  apiMonthlySalaryV2SendEmail,
  apiMonthlySalaryV2SendAllEmails,
  apiUpdateStatusOrderCOD,
  apiGetOrderActivities,
  apiGetDashBoardHome,
  apiGetDashBoardHomeSummary,
  apiGetDashBoardHomeStatusCounts,
  apiGetDashBoardHomeCharts,
  apiGetDashBoardHomeGrowth,
  apiGetDashBoardHomeDepartmentMonthly,
  apiGetIdCallerInfo,
  apiRequestRefund,
  apiGetOrdersProcessed,
  apiSearchOrderVTP,
  apiGetCars,
  apiGetTotalPriceOrder,
  apiGetListWeeklyBonus,
  apiWeeklyBonusList,
  apiWeeklyBonusSync,
  apiGetListCall,
  apiSearchInfoPhone,
  apiRestoreContact,
  apiStatistics,
  apiMergePDF,
  apiCheckStatusDBV,
  apiCheckStatusVTP,
  apiPrintPDFVTP,
  apiCreateVTP,
  apiUpdateOrderDesc,
  apiBrowsePayment,
  apiCreatePVI,
  apiGetPviPolicyNumber,
  apiCreateDiscountPrice,
  apiGetListDiscountPrice,
  apiGetDetailDiscountPrice,
  apiUpdateDiscountPrice,
  apiUpdateOrderNoteSale,
  apiUpdateOrderNotYetPaid,
  apiGetBrandCar,
  apiUpdateReturn,
  apiGetCategoryMoto,
  apiExportListOrder,
  apiCreateLpbi,
  apiUpdateStatusOrder,
  apiGetListCallIty,
  apiDetailDepartmentOrder
} from "./urls"

// const getAllowanceHistory = body =>
//   http.get(apiAllowanceHistory + `?${QueryString.stringify(body)}`)
// const salaryHistoryCreate = body => http.post(apiSalaryHistoryCreate, body)
// const salaryHistoryUpdate = (id, body) =>
//   http.put(apiSalaryHistoryUpdate(id), body)
// const salaryHistoryDelete = params =>
//   http.delete(apiSalaryHistoryDelete, { params })
// const getContractList = params => http.get(apiGetListContract, { params })
const postAssigned = params => http.post(apiAssigned, params)
const postFastAssigned = params => http.post(apiFastAssigned, params)
const getListPersonnel = params => http.get(apiListPersonnel, {params})
const exportOrder = params => http.get(apiExportOrder, {params})
const totalPrice = params => http.post(apiTotalPrice, params)
const orderUpdateStatus = params => http.put(apiOrderUpdateStatus, params)
const callLog = body => http.post(apiCallLog, body)
const getProvince = () => http.get(apiGetProvince)
const getDistrict = params => http.get(apiGetDistrict, {params})
const getWard = params => http.get(apiGetWard, {params})
const getStatistics = params => http.get(apiGetStatistics, {params})
const getGrowthStatistics  = params => http.get(apiGetGrowthStatistics, {params})
const getRolePermissions = (id, params) => http.get(apiGetRolePermissions(id), {params})
const getAllPermission = () => http.get(apiGetAllPermission)
const updateStatusOrderVTP = (body) => http.put(apiUpdateStatusOrderVTP, body)
const updateStatusOrderCOD = (id, body) => http.put(apiUpdateStatusOrderCOD(id), body)
const getOrderActivities = (id, params) => http.get(apiGetOrderActivities(id), { params })
const requestRefund = (id) => http.post(apiRequestRefund(id))
const updatePermissions = (id, body) => http.post(apiAssignPermissions(id), body)
const getSalary = (params) => http.get(apiSalary, {params})
const getTopSales = (params) => http.get(apiGetTopSales, {params})
const createSalaryConfig = body => http.post(apiCreateSalaryConfig, body)
const updateSalaryConfig = (id, body) => http.put(apiUpdateSalaryConfig(id), body)
const getSalaryConfig = () => http.get(apiGetSalaryConfig)
const getListSalaryConfig = (params) => http.get(apiGetListSalaryConfig, {params})
const getDetailSalaryConfig = (id) => http.get(apiGetDetailSalaryConfig(id))
const createSalaryConfigV2 = body => http.post(apiCreateSalaryConfigV2, body)
const updateSalaryConfigV2 = (id, body) => http.put(apiUpdateSalaryConfigV2(id), body)
const getListSalaryConfigV2 = params => http.get(apiGetListSalaryConfigV2, { params })
const getDetailSalaryConfigV2 = id => http.get(apiGetDetailSalaryConfigV2(id))
const deleteSalaryConfigV2 = id => http.delete(apiDeleteSalaryConfigV2(id))
const getAssignedDepartmentsV2 = params => http.get(apiGetAssignedDepartmentsV2, { params })
const getMonthlySalaryV2List = params => http.get(apiMonthlySalaryV2List, { params })
const getMonthlySalaryV2Detail = id => http.get(apiMonthlySalaryV2Detail(id))
const calculateMonthlySalaryV2 = body => http.post(apiMonthlySalaryV2Calculate, body)
const updateResponsibilityMoneyV2 = (id, body) => http.post(apiMonthlySalaryV2UpdateResponsibility(id), body)
const adjustMonthlySalaryV2 = (id, body) => http.post(apiMonthlySalaryV2Adjust(id), body)
const revertMonthlySalaryV2 = (id) => http.post(apiMonthlySalaryV2Revert(id))
const toggleCloseMonthlySalaryV2 = (body) => http.post(apiMonthlySalaryV2ToggleClose, body)
const sendMonthlySalaryV2Email = (id, body) => http.post(apiMonthlySalaryV2SendEmail(id), body)
const sendMonthlySalaryV2AllEmails = (body) => http.post(apiMonthlySalaryV2SendAllEmails, body)
const getDashBoardHome = (params) => http.get(apiGetDashBoardHome, {params})
const getDashBoardHomeSummary = (params) => http.get(apiGetDashBoardHomeSummary, {params})
const getDashBoardHomeStatusCounts = (params) => http.get(apiGetDashBoardHomeStatusCounts, {params})
const getDashBoardHomeCharts = (params) => http.get(apiGetDashBoardHomeCharts, {params})
const getDashBoardHomeGrowth = (params) => http.get(apiGetDashBoardHomeGrowth, {params})
const getDashBoardHomeDepartmentMonthly = (params) => http.get(apiGetDashBoardHomeDepartmentMonthly, {params})
const getIdCallerInfo = (params) => http.get(apiGetIdCallerInfo, {params})
const getOrdersProcessed = () => http.get(apiGetOrdersProcessed)
const searchOrderVTP = (params) => http.get(apiSearchOrderVTP, {params})
const getCars = () => http.get(apiGetCars)
const getTotalPriceOrder = (params) => http.get(apiGetTotalPriceOrder, { params })
const getListWeeklyBonus = (params) => http.get(apiGetListWeeklyBonus, { params })
const getWeeklyBonusList = (params) => http.get(apiWeeklyBonusList, { params })
const syncWeeklyBonus = (body) => http.post(apiWeeklyBonusSync, body)
const getListCall = (params) => http.get(apiGetListCall, { params })
const getListCallIty = (params) => http.get(apiGetListCallIty, { params })
const searchInfoPhone = (params) => http.get(apiSearchInfoPhone, { params })
const restoreContact = (params) => http.post(apiRestoreContact, params)
const statusOrder = (params) => http.get(apiStatistics, { params })
const mergePDF = body => http.post(apiMergePDF, body)
const checkStatusDBV = body => http.post(apiCheckStatusDBV, body)
const checkStatusVTP = body => http.post(apiCheckStatusVTP, body)
const printPDFVTP = body => http.post(apiPrintPDFVTP, body)
const createVTP = body => http.post( apiCreateVTP, body)
const updateOrderDesc = (id,body) => http.put( apiUpdateOrderDesc(id), body)
const updateOrderNoteSale = (id,body) => http.put( apiUpdateOrderNoteSale(id), body)
const browsePayment = (id) => http.put( apiBrowsePayment(id))
const createPVI = body => http.post( apiCreatePVI, body)
const getPviPolicyNumber = body => http.post(apiGetPviPolicyNumber, body)
const createDiscountPrice = body => http.post( apiCreateDiscountPrice, body)
const getListDiscountPrice = (params) => http.get(apiGetListDiscountPrice, { params })
const getDetailDiscountPrice = (id) => http.get(apiGetDetailDiscountPrice(id))
const updateDiscountPrice = (id, body) => http.put(apiUpdateDiscountPrice(id), body)
const updateOrderNotYetPaid = (id, body) => http.post(apiUpdateOrderNotYetPaid(id), body)
const getBrandCar = () => http.get(apiGetBrandCar)
const updateReturnOrder = (id, body) => http.put(apiUpdateReturn(id), body)
const getCategoryMoto = (body) => http.post(apiGetCategoryMoto, body)
const exportListOrder = (params) => http.get(apiExportListOrder, { params })
const createLpbi = (body) => http.post(apiCreateLpbi, body)
const updateStatusOrder = (id, body) => http.put(apiUpdateStatusOrder(id), body)
const detailDepartmentOrder = (id,params) => http.get(apiDetailDepartmentOrder(id), { params })

const CRMService = {
  postAssigned,
  postFastAssigned,
  getListPersonnel,
  exportOrder,
  totalPrice,
  orderUpdateStatus,
  callLog,
  getProvince,
  getDistrict,
  getWard,
  getStatistics,
  getGrowthStatistics,
  getRolePermissions,
  getAllPermission,
  updateStatusOrderVTP,
  updateStatusOrderCOD,
  getOrderActivities,
  requestRefund,
  updatePermissions,
  getSalary,
  getTopSales,
  createSalaryConfig,
  updateSalaryConfig,
  getSalaryConfig,
  getListSalaryConfig,
  getDetailSalaryConfig,
  createSalaryConfigV2,
  updateSalaryConfigV2,
  getListSalaryConfigV2,
  getDetailSalaryConfigV2,
  deleteSalaryConfigV2,
  getAssignedDepartmentsV2,
  getMonthlySalaryV2List,
  getMonthlySalaryV2Detail,
  calculateMonthlySalaryV2,
  updateResponsibilityMoneyV2,
  adjustMonthlySalaryV2,
  revertMonthlySalaryV2,
  toggleCloseMonthlySalaryV2,
  sendMonthlySalaryV2Email,
  sendMonthlySalaryV2AllEmails,
  getDashBoardHome,
  getDashBoardHomeSummary,
  getDashBoardHomeStatusCounts,
  getDashBoardHomeCharts,
  getDashBoardHomeGrowth,
  getDashBoardHomeDepartmentMonthly,
  getIdCallerInfo,
  getOrdersProcessed,
  searchOrderVTP,
  getCars,
  getTotalPriceOrder,
  getListWeeklyBonus,
  getWeeklyBonusList,
  syncWeeklyBonus,
  getListCall,
  getListCallIty,
  searchInfoPhone,
  restoreContact,
  statusOrder,
  mergePDF,
  checkStatusDBV,
  checkStatusVTP,
  printPDFVTP,
  createVTP,
  updateOrderDesc,
  browsePayment,
  createPVI,
  getPviPolicyNumber,
  createDiscountPrice,
  getListDiscountPrice,
  getDetailDiscountPrice,
  updateDiscountPrice,
  updateOrderNoteSale,
  updateOrderNotYetPaid,
  getBrandCar,
  updateReturnOrder,
  getCategoryMoto,
  exportListOrder,
  createLpbi,
  updateStatusOrder,
  detailDepartmentOrder
}

export default CRMService

